import React from 'react';

import ControlledNumericValueEditor from 'schemas/tags/ControlledNumericValueEditor';
import {ElementKeyboardEvent} from 'util/Types';

export interface ControlledIntegerValueEditorProps {
  defaultValue?: {value?: string | number | null} | null;
  placeholder?: string;
  autoFocus: boolean;
  onChange: (tag: {integerValue: number | string; value: string | null}) => void;
  value?: string | number | null;
  onKeyDown?: (e: ElementKeyboardEvent) => void;
}

export default function ControlledIntegerValueEditor(props: ControlledIntegerValueEditorProps): JSX.Element {
  return (
    <ControlledNumericValueEditor
      {...props}
      valueAccessorKey="integerValue"
      useStringValue={true}
      placeholder={props.placeholder ?? 'Integer Value'}
    />
  );
}
